import Vue from 'vue'
import VueApollo from 'vue-apollo'
import { createApolloClient, restartWebsockets } from 'vue-cli-plugin-apollo/graphql-client'
import cache from './cache'
import { setContext } from '@apollo/client/link/context';
import errorLink from './errorLink'
import { from } from '@apollo/client/core'
import store from '@/store';
import gql from 'graphql-tag'
// Install the vue plugin
Vue.use(VueApollo)

// Name of the localStorage item
export const AUTH_TOKEN = 'apollo-token'

const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem(AUTH_TOKEN);
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      Authorization: token ? `Bearer ${token}` :  null,
    }
  }
});

// Http endpoint
if (process.env.VUE_APP_API_HOST == null) {
  console.error('Please set VUE_APP_API_HOST in your .env file')
}

const httpHost = process.env.VUE_APP_API_HOST != null ? process.env.VUE_APP_API_HOST : 'https://localhost'

const httpEndpoint = `${httpHost}/graphql`

// Config
const defaultOptions = {
  // You can use `https` for secure connection (recommended in production)
  httpEndpoint,
  // You can use `wss` for secure connection (recommended in production)
  // Use `null` to disable subscriptions
  wsEndpoint: null,
  // LocalStorage token
  tokenName: AUTH_TOKEN,
  // Enable Automatic Query persisting with Apollo Engine
  persisting: false,
  // Use websockets for everything (no HTTP)
  // You need to pass a `wsEndpoint` for this to work
  websocketsOnly: false,
  // Is being rendered on the server?
  ssr: false,

  // Override default apollo link
  // note: don't override httpLink here, specify httpLink options in the
  // httpLinkOptions property of defaultOptions.
  link: from([errorLink, authLink]),

  // Override default cache
  cache: cache,

  // Override the way the Authorization header is set
  // getAuth: (tokenName) => ...

  // Additional ApolloClient options
  // apollo: { ... }

  // Client local data (see apollo-link-state)
  // clientState: { resolvers: { ... }, defaults: { ... } }
  resolvers: {},
}

export const { apolloClient, wsClient } = createApolloClient({
  ...defaultOptions
  // ...options
})

// Call this in the Vue app file
export function createProvider (options = {}) {
  // Create apollo client
  const { apolloClient, wsClient } = createApolloClient({
    ...defaultOptions,
    ...options,
  })
  apolloClient.wsClient = wsClient

  // Create vue apollo provider
  const apolloProvider = new VueApollo({
    defaultClient: apolloClient,
    defaultOptions: {
      $query: {
        // fetchPolicy: 'cache-and-network',
      },
    },
    errorHandler (error) {
      // eslint-disable-next-line no-console
      console.error('%cError', 'background: red; color: white; padding: 2px 4px; border-radius: 3px; font-weight: bold;', error.message)
    },
  })

  return apolloProvider
}

// Manually call this when user log in
export async function onLogin (apolloClient, token, userId) {
  if (typeof localStorage !== 'undefined' && token) {
    store.commit('setGetMe', userId)
    localStorage.setItem(AUTH_TOKEN, token)
  }

  if (apolloClient.wsClient) restartWebsockets(apolloClient.wsClient)
  try {
    // Skip clearStore() on login to prevent "Store reset" errors and empty pages.
    // reFetchObservableQueries will update the cache with authenticated data.
    await apolloClient.reFetchObservableQueries()
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('%cError on cache re-fetch (login)', 'color: orange;', e.message)
  }

  store.dispatch("onLogin", apolloClient);
}

// Manually call this when user log out
export async function onLogout (apolloClient) {
  if (typeof localStorage !== 'undefined') {
    // Check if the user was logged before clearing cart
    if (store.state.auth.getMe) {
      store.commit('setGetMe', null)
      store.commit('setCurrentCart', null)
      store.commit('setCartOwner', null)
    }
    localStorage.removeItem(AUTH_TOKEN)
  }
  if (apolloClient.wsClient) restartWebsockets(apolloClient.wsClient)
  try {
    await apolloClient.clearStore()
    await apolloClient.reFetchObservableQueries()
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('%cError on cache reset (logout)', 'color: orange;', e.message)
  }
}
